import React, { useState } from 'react';
import { Search, SlidersHorizontal } from 'lucide-react';
import { Store } from '../../types';
import { StoreCard } from '../StoreCard';
import { STORES } from '../../data/mockData';
import { Input } from '../ui/Input';
interface ExploreScreenProps {
  onStoreClick: (store: Store) => void;
}
export function ExploreScreen({
  onStoreClick
}: ExploreScreenProps) {
  const [search, setSearch] = useState('');
  const [activeFilter, setActiveFilter] = useState('All');
  const filters = ['All', 'Coffee', 'Food', 'Books', 'Retail', 'Bar'];
  const filteredStores = STORES.filter(store => {
    const matchesSearch = store.name.toLowerCase().includes(search.toLowerCase());
    const matchesFilter = activeFilter === 'All' || store.tags.some(tag => tag.includes(activeFilter));
    return matchesSearch && matchesFilter;
  });
  return <div className="pb-24 pt-6 px-4 h-full flex flex-col animate-in fade-in duration-500" data-id="element-263">
      <h1 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-264">Explore Nearby</h1>

      {/* Search & Filter */}
      <div className="sticky top-0 bg-white z-10 pb-4 space-y-4" data-id="element-265">
        <div className="flex gap-3" data-id="element-266">
          <Input placeholder="Search stores..." icon={<Search size={18} data-id="element-268" />} value={search} onChange={e => setSearch(e.target.value)} className="bg-gray-50 border-none" data-id="element-267" />
          <button className="p-3 bg-gray-50 rounded-xl text-gray-600 hover:bg-gray-100" data-id="element-269">
            <SlidersHorizontal size={20} data-id="element-270" />
          </button>
        </div>

        <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide -mx-4 px-4" data-id="element-271">
          {filters.map(filter => <button key={filter} onClick={() => setActiveFilter(filter)} className={`
                px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-colors
                ${activeFilter === filter ? 'bg-purple-600 text-white shadow-md shadow-purple-600/20' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}
              `} data-id="element-272">
              {filter}
            </button>)}
        </div>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 gap-6 mt-2" data-id="element-273">
        {filteredStores.map(store => <StoreCard key={store.id} store={store} onClick={() => onStoreClick(store)} showCheckIn onCheckIn={() => onStoreClick(store)} // In real app, this might go straight to check-in flow
      data-id="element-274" />)}
      </div>
    </div>;
}